import React, { useEffect, useState } from "react";
import { Button, Dropdown, Tab, Tabs, Nav, Accordion } from 'react-bootstrap';
import LeadListTable from './LeadLIstTable'
import LeadListFilter from './LeadListTopFilter'
import LeadDetailTabs from "./LoanFiledTabs";
import { executeGraphQLQuery } from "../../../services/inventory-funding/executeGraphQLQuery";
import { GET_USER_LIST } from "../../../services/inventory-funding/leads.gql";
import { useApolloClient } from "@apollo/client";
import { CUSTOMER_VIEW_LIST, TASK_VIEW_LIST } from "../../../services/inventory-funding/opsee.gql";
import { toast } from "react-toastify";
import Loader from "../elements/Loader";
import CustomerListTable from "./CustomerLIstTable";
import { MASTERDATA_QUERY } from "../../../services/inventory-funding/dashboard.gql";
import { useSelector } from "react-redux";

const FCILeadList = (props) => {
  const client = useApolloClient();
  const [showSurveyRequest, setShowSurveyRequest] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [taskViewList, setTaskViewList] = useState({});
  const [customerViewList, setCustomerViewList] = useState({});
  const [offset, setOffset] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pageCountCustomer, setPageCountCustomer] = useState(0);
  const [filterData, setFilterData] = useState({});
  const [activeTab, setActiveTab] = useState('first');
  const [viewList, setViewList] = useState('task');
  const [provinceList, setProvinceList] = useState([]);
  const [cityList, setCityList] = useState([]);
  let logInUserInfo = useSelector(({ user }) => user.user_information) || {};
  logInUserInfo = JSON.parse(logInUserInfo);

  useEffect(() => {
    getUserList();
    getMasterData();
  },[])

  useEffect(()=> {
    if(viewList === 'task') getTaskViewList(filterData,offset);
    if(viewList === 'customer') getCustomerViewList({},0);
  },[filterData,offset,viewList])


  const showModalSurveyRequest = () => {
    setShowSurveyRequest(true);
    document.body.classList.add('overflow-hidden');
  };


  const hideModalSurveyRequest = () => {
    setShowSurveyRequest(false);
    document.body.classList.remove('overflow-hidden');
  };

  const getMasterData = async () => {
    executeGraphQLQuery(MASTERDATA_QUERY(),{"api_called_by":"web","master_data":["region_city"]}, client)
    .then((res) => {
    if(res?.data){
      setProvinceList(res?.data?.masterdata?.region_city?.state);
      setCityList(res?.data?.masterdata?.region_city?.city)
    }else{
      toast.error("Something went wrong")
    }
    })
    .catch((error) => {
        toast.error(error.toString().replace('ApolloError:',''));
    });
    
  
}

  const getUserList = async (params) => {
    setUserList([]);
    let user_list = [];
    let variables= {
      role_id: 0,
      checker_role_id: 0,
      is_redis_force_update: true,
    }
    await executeGraphQLQuery(GET_USER_LIST(), variables, client, 0).then((response) => {
        if (response && response.data && response.data.get_user_list) {
            user_list = params?.status ? response.data.get_user_list.filter(obj => obj.status == params.status) : response.data.get_user_list;
            setUserList(user_list);
        }

    }).catch((error) => {
        console.log(error);
    });
  }

  const getTaskViewList = async (filterData={},page=0) => {
    setLoading(true)
    let variables= {
      taskViewInput: {
        source: 'web',
        page_num: page+1,
        task_status:'0',
        role_id: logInUserInfo?.role_id,
        ...filterData
      },
    }
    await executeGraphQLQuery(TASK_VIEW_LIST(), variables, client).then((response) => {
        if (response && response.data && response.data.task_view_list) {
            let list = response.data.task_view_list;
            setTaskViewList(list);
            setPageCount(list?.pagination?.totalrecords);
            setLoading(false);
        } else {
          toast.error("Something went wrong");
          setLoading(false);
        }

    }).catch((error) => {
      setLoading(false);
      toast.error(error.toString().replace("ApolloError:", ""));
      console.log(error);
    });
  }

  const getCustomerViewList = async (filterData={},page=0) => {
    setLoading(true)
    let variables= {
      customerViewInput: {
        source: 'web',
        page_num: page+1,
        role_id: logInUserInfo?.role_id,
        ...filterData
      },
    }
    await executeGraphQLQuery(CUSTOMER_VIEW_LIST(), variables, client).then((response) => {
        if (response && response.data && response.data.customer_view_list) {
            let list = response.data.customer_view_list;
            setCustomerViewList(list);
            setPageCountCustomer(list?.pagination?.totalrecords);
            setLoading(false);
        } else {
          toast.error("Something went wrong");
          setLoading(false);
        }

    }).catch((error) => {
      setLoading(false);
      toast.error(error.toString().replace("ApolloError:", ""));
      console.log(error);
    });
  }

  const handlePageClick = (selectedPage) => {
    setOffset(selectedPage);
    setFilterData((prev)=>({...prev,page_num: selectedPage+1}))
  };

  const submitFilterForm = (filterData) => {
    setFilterData(filterData);
    setOffset(0);
    getTaskViewList({ ...filterData },0);
  }

  let IfUserRoles=[23,27,28,29,33];
  let userListDD = userList?.filter(v=> v.role_assigned_ids?.split(",")?.map(n => Number(n)).some(r=> IfUserRoles.includes(r)));
  userListDD = userListDD?.map(v=>({
    value: v.user_id,
    label: v.name,
  }));

  console.log("*************8",logInUserInfo)
  return (
    <React.Fragment>
      {loading ? <Loader/> : ''}
      <div className="container-fluid">
        <div className="top-heading fci-heading">
          <h1>FCI Survey Panal</h1>
          <Button className="btn btn-primary add-mapping-link" onClick={showModalSurveyRequest}>Add Survey Request</Button>
        </div>
        <div className="loan-filter-bg">

          <div className="top-filter-bg">
            <LeadListFilter 
              filterData={filterData}
              setFilterData={setFilterData}
              loading={loading}
              setOffset={setOffset}
              onSubmitFilter={submitFilterForm}
              userList={userListDD}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
           
          </div>
        

        </div>
        <div className="fci-flow-list-tabs">
          <Tab.Container id="left-tabs-example" activeKey={activeTab} onSelect={(k)=> setActiveTab(k)}>

                    <Nav variant="pills" className="flex-column p-lg-b">
                        <div className="tab-list d-flex">
                            {viewList === 'task' && <><Nav.Item>
                                <Nav.Link eventKey="first" disabled={taskViewList?.tabs?.unassigned === 0} onClick={()=> {setActiveTab('first'); setFilterData((prev)=>({...prev,task_status:'0',page_num: 1})); setOffset(0);}}>Unassigned <span>{taskViewList?.tabs?.unassigned || 0}</span></Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="second"disabled={taskViewList?.tabs?.assigned_unacknowledged === 0} onClick={()=> {setActiveTab('second'); setFilterData((prev)=>({...prev,task_status:'1',page_num: 1})); setOffset(0);}}>Assigned | Unacknowledged <span>{taskViewList?.tabs?.assigned_unacknowledged || 0}</span></Nav.Link>
                            </Nav.Item>
                              <Nav.Item>
                                <Nav.Link eventKey="third" disabled={taskViewList?.tabs?.assigned_acknowledged === 0} onClick={()=> {setActiveTab('third');setFilterData((prev)=>({...prev,task_status:'2',page_num: 1})); setOffset(0);}}>Assigned | Acknowledged <span>{taskViewList?.tabs?.assigned_acknowledged || 0}</span></Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="fourth" disabled={taskViewList?.tabs?.completed === 0} onClick={()=> {setActiveTab('fourth');setFilterData((prev)=>({...prev,task_status:'3',page_num: 1})); setOffset(0);}}>Completed <span>{taskViewList?.tabs?.completed || 0}</span></Nav.Link>
                            </Nav.Item>
                              <Nav.Item>
                                <Nav.Link eventKey="fifth" disabled={taskViewList?.tabs?.overdue === 0} onClick={()=> {setActiveTab('fifth');setFilterData((prev)=>({...prev,task_status:'4',page_num: 1})); setOffset(0);}}>Overdue <span>{taskViewList?.tabs?.overdue || 0}</span></Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="sixth" disabled={taskViewList?.tabs?.rejected === 0} onClick={()=> {setActiveTab('sixth');setFilterData((prev)=>({...prev,task_status:'5',page_num: 1})); setOffset(0);}}>Cancelled <span>{taskViewList?.tabs?.rejected || 0}</span></Nav.Link>
                            </Nav.Item></>}
                        </div>
                        <div className="btn-right">
                          <button className={viewList === 'task' ? "btn-primary" : "btn-line"} onClick={()=> setViewList('task')}>Task View</button>
                          <button className={viewList === 'customer' ? "btn-primary m-sm-l": "btn-line m-sm-l"}  onClick={()=> setViewList('customer')}>Customer View</button>
                        </div>

                    </Nav>

                    {viewList === 'task' && <div>
                      <LeadListTable pageCount={pageCount} offset={offset} handlePageClick={handlePageClick} taskViewList={taskViewList} userList={userListDD} activeTab={activeTab} setLoading={setLoading} getTaskViewList={getTaskViewList} filterData={filterData} logInUserInfo={logInUserInfo}/>
                    </div>}
                    {viewList === 'customer' && <div>
                      <CustomerListTable pageCount={pageCountCustomer} offset={offset} handlePageClick={handlePageClick} customerViewList={customerViewList} getCustomerViewList={getCustomerViewList} setLoading={setLoading} filterData={filterData} logInUserInfo={logInUserInfo}/>
                    </div>}

          </Tab.Container>
        </div>

        <div className="add-survey-flow-popup">
        <Modal
          show={showSurveyRequest}
          handleClose={hideModalSurveyRequest}
        >
          <div className="modal-body">
            <LeadDetailTabs getTaskViewList={getTaskViewList} hideModalSurveyRequest={hideModalSurveyRequest} provinceList={provinceList} cityList={cityList}/>
          </div>
        </Modal>
      </div>
      </div>
    </React.Fragment>
  )
}
const Modal = ({ handleClose, show, children }) => {
  const showHideClassName = show
    ? 'modal display-block'
    : 'modal display-none';

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        {children}
        <button
          onClick={handleClose}
          className="close_icn"
        >
          <i className="ic-clearclose"></i>
        </button>
      </section>
    </div>
  );
};
export default FCILeadList;